export default __webpack_public_path__ + "static/media/refresh.d386ddaa.svg";